import { createApp } from "vue";
import { createBootstrap } from "bootstrap-vue-next";
import VueCookies from "vue-cookies";
import I18NextVue from "i18next-vue";
import { createAuth0 } from "@auth0/auth0-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18next from "./i18n.js";
import { apolloProvider } from "./util/apollo-client";
import AppConfig from "./app-config";
import Authentication from "./util/Authentication";
import "./vendor.js";
import "./util/Logger.js";

// ag-Grid
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";

// Highcharts
import HighchartsVue from "highcharts-vue";

// Bootstrap Vue Next styles
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";

// Validate Auth0 configuration
const auth0Domain = AppConfig.auth0Domain;
const auth0ClientId = AppConfig.auth0ClientId;

if (!auth0Domain || !auth0ClientId) {
  console.error("⚠️ Auth0 configuration missing!");
  console.error("Please set VITE_AUTH0_DOMAIN and VITE_AUTH0_CLIENT_ID in your .env file");
  console.error("See .env.auth0-template for reference");
}

// Create Vue app
const app = createApp(App);

// Install Auth0 (if configured)
let auth0Plugin = null;
if (auth0Domain && auth0ClientId) {
  auth0Plugin = createAuth0({
    domain: auth0Domain,
    clientId: auth0ClientId,
    authorizationParams: {
      redirect_uri: window.location.origin,
      ...(AppConfig.auth0Audience && { audience: AppConfig.auth0Audience }),
    },
  });
  app.use(auth0Plugin);
} else {
  console.warn("⚠️ Running without Auth0 - authentication disabled");
}

// Install other plugins
app.use(router);
app.use(store);
app.use(createBootstrap({ components: true, directives: true }));
app.use(VueCookies);
app.use(I18NextVue, { i18next });
app.use(HighchartsVue);
app.use(apolloProvider);

// Mount app and initialize Auth0 access after mounting
app.mount("#app");

// After mounting, set up a global watcher to initialize Auth0 in Authentication utility
// This ensures router can access Auth0 immediately
if (auth0Plugin) {
  // Use a microtask to ensure app is fully mounted
  Promise.resolve().then(() => {
    // Get the Auth0 instance from the root component
    const auth0Instance = app.config.globalProperties.$auth0;
    if (auth0Instance) {
      Authentication.setAuth0Instance(auth0Instance);
    }
  });
}
